import { useContext, useState } from "react";
import { ChatContext } from "../../contexts/ChatContext";
import ChatHeader from "./ChatHeader";
import ChatMessages from "./ChatMessages";
import ChatInput from "./ChatInput";
import Fab from "@mui/material/Fab";
import Drawer from "@mui/material/Drawer";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutlined";

export default function ChatWidget() {
  const { chatEnabled, isOpen, setIsOpen, isPinned } = useContext(ChatContext);

  const [isNew, setIsNew] = useState(
    () => !localStorage.getItem("chatWidgetSeen"),
  );

  if (!chatEnabled) return null;

  const handleOpen = () => {
    setIsOpen(true);
    if (isNew) {
      localStorage.setItem("chatWidgetSeen", "true");
      setIsNew(false);
    }
  };

  return (
    <>
      {!isOpen && (
        <Fab
          color="primary"
          aria-label="Open support chat"
          onClick={handleOpen}
          sx={{
            position: "fixed",
            bottom: { xs: 16, md: 24 },
            right: { xs: 16, md: 24 },
            zIndex: (theme) => theme.zIndex.drawer + 1,
            "@keyframes pulse": {
              "0%": { boxShadow: "0 0 0 0 rgba(25, 118, 210, 0.7)" },
              "70%": { boxShadow: "0 0 0 14px rgba(25, 118, 210, 0)" },
              "100%": { boxShadow: "0 0 0 0 rgba(25, 118, 210, 0)" },
            },
            animation: isNew ? "pulse 2s infinite" : "none",
          }}
          size="large"
        >
          <ChatBubbleOutlineIcon />
        </Fab>
      )}
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        variant={isPinned ? "persistent" : "temporary"}
        sx={{ zIndex: 1300 }}
        {...(!isPinned && { ModalProps: { keepMounted: true } })}
        slotProps={{
          paper: {
            sx: {
              width: { xs: "100vw", sm: 400 },
              display: "flex",
              flexDirection: "column",
            },
          },
        }}
      >
        <ChatHeader showClose />
        <ChatMessages />
        <ChatInput />
      </Drawer>
    </>
  );
}
